import React from "react";
import numeral from "numeral";
import { useTranslation } from "react-i18next";
const GaugeDetails = ({ metric: { metric: gauge } }) => {
  const { t } = useTranslation("system");
  return /* @__PURE__ */ React.createElement("dl", { className: "metric-def metric-gauge" }, /* @__PURE__ */ React.createElement("dt", null, t("metric_details.value")), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement("span", { className: "number-format" }, numeral(gauge.value).format("0,0"))));
};
export default GaugeDetails;
